import React from 'react'

import { Row, Text } from '@vividseats/vivid-ui-kit'

interface FaceValueProps {
    faceValue: string | null
    className: string
}
const FaceValue: React.FC<FaceValueProps> = (props) => {
    return (
        <Row align="baseline">
            <Text altFont data-test-id="face-value-price" size="sm" state="muted" className={props.className}>
                {props.faceValue ? `Face Value: ${props.faceValue} ea.` : 'Face Value not provided by seller'}
            </Text>
        </Row>
    )
}

export default FaceValue
